module.exports = __webpack_public_path__ + "static/img/ic_lock.8e1e5ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_lock.png
// module id = z1Ix
// module chunks = 1